/**
	* Zoom box view
	* Handles: zoom box, snapping box
	* @module ZoomBox
*/

/// Imports

// React
import React, {useState, useEffect} from "react";

// OpenLayers
import OlMap from "ol/Map";

// Models
import MapToolMode from "lib/enums/maptoolmode";

// Tools
import { assetURL } from "lib/utilities/asset";

// Lang
import { getLocaleString } from "lib/localization/vendor";

interface ZoomBoxProps {
	olMap:OlMap,
	zoomLevel:number,
	currentToolMode:MapToolMode
}

var initialized = false;
var mapConfig:any;

export default function ZoomBox({olMap, zoomLevel, currentToolMode}:ZoomBoxProps) {
	mapConfig = olMap.get('opus-config');
	
	const [rightPanelDisplaying, setRightPanelDisplaying] = useState<boolean>(false);
		
	const snapping:boolean = !(zoomLevel < _config.minZoomSnapping);
	
	const initialize = () => {
		_events.on("right-panel-update", (visible:boolean) => {
			// Encased in timeout to avoid state change overlapping with other components
			setTimeout(() => setRightPanelDisplaying(visible), 25);
		});
		initialized = true;
	}
	
	/**
		* Should zoom box hide?
		* @return true/false depending on screen size
	*/
	const shouldHide = ():boolean => {
		return ((currentToolMode != MapToolMode.Select && currentToolMode != MapToolMode.Draw && currentToolMode != MapToolMode.Annotation && currentToolMode != MapToolMode.Measure) || (rightPanelDisplaying)) && _dimensions.width < 475;
	}
	const drawZoomBox = () => {
		const visible:boolean = !shouldHide();
		let className:string = `rect rect__zoombox${visible ? "" : " rect__zoombox--hidden"}`;
		
		if(!_ui.getZoomBarEnabled(mapConfig))
			className += ' rect__zoombox--after-zoom-bar';
		
		return (
			<div className={className} data-tip={getLocaleString("zoomlevel")}>
				<img src={assetURL("assets/images/zoom.png")} /> 
				<b>{Math.round(zoomLevel)}</b>
			</div>
		)
	}
	const drawSnapBox = () => {
		const visible:boolean = !shouldHide();
		const className:string = `rect rect__snapbox${visible ? "" : " rect__snapbox--hidden"}${!snapping ? " rect__snapbox--disabled" : ""}`;
		
		return (
			<div className={className} data-tip={snapping ? getLocaleString("snappingon") : getLocaleString("snappingoff")}>
				<img src={assetURL("assets/images/snapping.png")} /> 
			</div>
		)
	}
	
	if(!initialized) initialize();
	
	return (
		<>
			{drawZoomBox()}
		</>
	)
}